import { callApiWithoutToken } from './api';

import { ApiResult } from '@/types/api';
import { MonthlyCalendarItem } from '@/types/monthlyCalendar';

export const getLineUserCalendar = async (
  lineAccessToken: string,
  date: string
): Promise<ApiResult<MonthlyCalendarItem>> => {
  const searchParams = new URLSearchParams({
    date: date, // YYYY-MM-DD形式
  });
  const { status, result } = await callApiWithoutToken<MonthlyCalendarItem>(
    `line/reservation/calendar`,
    'GET',
    lineAccessToken,
    searchParams
  );
  return { status, result };
};
